function _typeof (e) {
  return (_typeof =
    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
      ? function (e) {
          return typeof e
        }
      : function (e) {
          return e &&
            'function' == typeof Symbol &&
            e.constructor === Symbol &&
            e !== Symbol.prototype
            ? 'symbol'
            : typeof e
        })(e)
}
var ku_translations = {
    en: {
      viewAll: 'View All',
      ProductResults: 'Products Results',
      articles: 'Articles',
      products: 'Products',
      blog: 'Blog Articles',
      filterBy: 'Filter By',
      apply: 'Apply Filters & Close',
      youMayAlsoLike: 'You May Also Like',
      noCMS: 'No suitable articles found.',
      noProducts: 'No suitable products found.'
    }
  },
  klevu_enableLandingAutoScroll = !0,
  klevu_uc = {
    showLandingPageData: function (e) {
      var t,
        l,
        n,
        r,
        a,
        i,
        s = '',
        o = '',
        u = document.getElementById('searchedKeyword').value,
        c = '',
        d = 0,
        v = 0,
        k = 0,
        m = !1,
        g = '',
        p = 5,
        y = !0,
        h = '',
        _ = document.createElement('div'),
        f = !!e.additionalDataToReturn && JSON.parse(e.additionalDataToReturn)
      ;((e = klevu_productCustomizations(e)).additionalFlags = f),
        0 === e.productImage.trim().length && (e.productImage = klevu_userOptions.noImageUrl),
        (o = klevu_userOptions.openProductClicksInNewWindow
          ? ' target="_blank"'
          : ' onclick="klevu_analytics.stopClickDefault( event );" target="_self"'),
        (t =
          "{data: {code: '" +
          escape(e.productCode) +
          "',url: '" +
          escape(e.productUrl) +
          "',name: '" +
          escape(e.productName) +
          "',salePrice: '" +
          escape(e.salePrice) +
          "',rating: '" +
          escape(e.rating) +
          "',position: " +
          e.productPosition +
          ",category: '" +
          escape(e.category) +
          "',sku: '" +
          escape(e.sku) +
          "'},apiKey: null,keywordsLP: '" +
          escape(u) +
          "'}"),
        (c = klevu_commons.isMobileDevice()
          ? ' onclick="return klevu_analytics.trackClickedProduct(event, ' +
            t +
            ');" target="_self">'
          : ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' +
            t +
            ');" onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
            t +
            ', klevu_analytics.trackClickedProduct);" ' +
            o +
            '>')
      try {
        s += `<li>`
        s += `<div class="prd-Card util-FauxLink" data-product-id="${e.productCode}">`
        s += `<a class="prd-Card_FauxLink util-FauxLink_Link" href="${e.productUrl.replace(
          /"/g,
          '%22'
        )}" target="_blank"></a>`
        s += `<div class="prd-Card_ImageContainer">`
        const productImage =
          e.productImage.indexOf('_400x800.jpg') >= 0
            ? e.productImage.replace('_400x800.jpg', '_900x.jpg')
            : e.productImage
        s += `<div class="prd-Card_Image"><img src="${productImage}" class="prd-Card_KlevuImage" onerror="this.onerror=null;this.src='${
          klevu_userOptions.noImageUrl
        }';" alt="${klevu_commons.escapeHtml(e.productName)}"/></div>`
        if (e.imageHover) {
          const hoverImage =
            e.imageHover.indexOf('_400x800.jpg') >= 0
              ? e.imageHover.replace('_400x800.jpg', '_900x.jpg')
              : e.imageHover
          s += `<div class="prd-Card_ImageHover"><img src="${hoverImage}" class="prd-Card_KlevuImage" alt="${klevu_commons.escapeHtml(
            e.productName
          )}" /></div>`
        }
        s += '</div>'
      } catch (e) {}
      if (
        typeof klevu_showDiscountBadge !== 'undefined' &&
        klevu_showDiscountBadge &&
        e.discount != '' &&
        e.discount != '0' &&
        e.discount != '0.0'
      ) {
        if (klevu_uiLabels.discountBadgeText.indexOf('#') === -1) {
          s += `<div class="kuDiscountBadge">${klevu_uiLabels.discountBadgeText} ${Number(
            e.discount
          ).toFixed(0)}%</div>`
        } else {
          s += `<div class="kuDiscountBadge">${klevu_uiLabels.discountBadgeText.replace(
            '#',
            `${Number(e.discount).toFixed(0)}%`
          )}</div>`
        }
      }
      s += '<div class="prd-Card_Content">'
      if (e.category && e.category.includes(';;')) {
        s += `<h4 class="prd-Card_Type fz-1218">${e.category.split(';;')[1]}</h4>`
      } else if (e.category) {
        s += `<h4 class="prd-Card_Type fz-1218">${e.category}</h4>`
      }
      s += `<h3 class="prd-Card_Title fz-1525">${e.productName
        .split('|')[0]
        .replace('·', '<br />')
        .toLowerCase()}</h3>`
      // Variant name
      // s += `<div class="prd-Card_Title fz-1422">${e.current}</div>`
      s += `<div class="prd-Card_Sku fz-1422">${e.sku}</div>`
      s += '</div>'
      if (klevu_showPrices) {
        s += '<div class="prd-Card_Footer">'
        s += '<div class="prd-Card_Price fz-1525">'
        // ***********************
        // Calculate price based on customer trade tag, the same as in product_price.liquid

        if (e.inStock !== 'yes') {
          s += `<span class="prd-Product_Price">${klevu_uiLabels.outOfStock}</span>`
        } else {
          var price = e.price

          // 1) If trade, price = product.metafields.prices.wholesale
          if (window.theme.customer.isTradeAccount) {
            price = e.wholesale / 100
          } else {
            // 2) Else, price = current_variant.price | times: 1.2 | round: 2
            if (e.priced_by === 'ITEM') {
              // For some reason, in the e object price is the same as wholesale. The only way I
              // can match the PLP price is to use startPrice.
              price = e.startPrice * 1.2
            } else {
              price = e.price * 1.2
            }
          }

          // 3) If product.metafields.quantity.increment != blank
          //      price = current_price | divided_by: increment_amount | round
          if (e.increment && e.increment > 0) {
            price = price / e.increment
          }

          // s += klevu_landingProductElements.showPrices(xx, 'prd-Product_Price').replace('.00', '')
          s += `<div class="prd-Product_Price">
            <span class="prd-Price_Value">${e.currency}${price.toFixed(2)}</span>
            <span class="prd-Price_Measure">/ ${e.priced_by}</span>
          </div>`
        }

        s += '</div>'
        s += '</div>'
      }
      if (klevu_commons.showAddToCartButton(e.inStock, e.hideAddToCart)) {
        s += klevu_landingProductElements.showAddtocart(e)
      }
      s += '</div>'
      s += '</li>'
      return s
    },
    showProductPrices: function (e, t, l, n) {
      if (
        'undefined' != typeof klevu_groupListCategory &&
        klevu_groupListCategory &&
        t.hideGroupPrices &&
        -1 !== t.hideGroupPrices.indexOf(klevu_groupListCategory)
      )
        return ''
      var r,
        a,
        i,
        s,
        o,
        u,
        c,
        d,
        v = '',
        k = 0
      if (
        (t.productPrice.indexOf(t.currency) >= 0 && (t.currency = ''),
        '0' === t.productPrice.trim() && (t.productPrice = ''),
        -1 !== klevu_currenciesAppendedAtEnd.indexOf(t.currency) && (o = !0),
        'undefined' != typeof klevu_currentCurrencyCode &&
          klevu_currentCurrencyCode &&
          'undefined' != typeof klevu_currentCurrencyRates &&
          klevu_currentCurrencyRates &&
          klevu_currentCurrencyCode !== t.currency &&
          klevu_currencySymbols[klevu_currentCurrencyCode] !== t.currency &&
          klevu_currentCurrencyRates[klevu_currentCurrencyCode])
      ) {
        var m = 0,
          g = klevu_currentCurrencyRates[klevu_currentCurrencyCode]
        g.split(':').length >= 2 && (m = g.split(':')[0]),
          m > 0 &&
            (t.productPrice && (t.productPrice = (Number(t.productPrice) * m).toString()),
            t.startPrice && (t.startPrice = (Number(t.startPrice) * m).toString()),
            t.toPrice && (t.toPrice = (Number(t.toPrice) * m).toString()),
            t.priceToDisplay && (t.priceToDisplay = (Number(t.priceToDisplay) * m).toString()),
            t.salePrice && (t.salePrice = (Number(t.salePrice) * m).toString()),
            g.split(':')[1].trim().length > 0 && (t.currency = g.split(':')[1]),
            g.split(':').length > 2 && (o = 'true' === g.split(':')[2]))
      }
      if (
        ((d = klevu_userOptions.priceFormatter),
        (!t.priceToDisplay && !t.startPrice && !t.toPrice) ||
          !t.totalProductVariants ||
          '0' === t.totalProductVariants)
      )
        if (
          ((u = Number(t.productPrice).formatMoneyForKlevu(
            d.decimalPlaces,
            '',
            d.thousandSeparator,
            d.decimalSeparator
          )),
          (c =
            '<span class="money">' +
            (c = klevu_commons.addCurrencyToPrice(u, t.currency, o)) +
            '</span>'),
          t.productPrice.trim().length > 0 &&
          t.salePrice.trim().length > 0 &&
          t.productPrice != t.salePrice &&
          '0.00' !== t.productPrice &&
          '0' !== t.productPrice &&
          Number(t.productPrice).toFixed(2) != Number(t.salePrice).toFixed(2)
            ? 'SLIM' === e
              ? ((v += klevu_layout.getPriceDivs('ORIG', c, '')), (l = n))
              : 'BASIC' === e
              ? ((v += klevu_layout.getPriceDivs('ORIG', c, '')), (l = n))
              : 'LANDING' === e && ((v += klevu_getPriceDivs('ORIG', c, '')), (l = n))
            : t.productPrice.trim().length > 0 &&
              '0.00' !== t.productPrice &&
              '0.0' !== t.productPrice &&
              '0' !== t.productPrice &&
              ('SLIM' === e
                ? (v += klevu_layout.getPriceDivs('SALE', c, '', l))
                : 'BASIC' === e
                ? (v += klevu_layout.getPriceDivs('SALE', c, '', l))
                : 'LANDING' === e && (v += klevu_getPriceDivs('SALE', c, '', l))),
          t.salePrice.trim().length > 0 &&
            t.productPrice != t.salePrice &&
            0 === t.priceToDisplay.trim().length &&
            '0.00' !== t.salePrice &&
            '0' !== t.salePrice &&
            '0.0' !== t.salePrice &&
            Number(t.productPrice).toFixed(2) != Number(t.salePrice).toFixed(2))
        ) {
          if (((r = t.salePrice), t.groupPrices.trim().length > 0))
            for (
              document.getElementById('klevu_loginCustomerGroup')
                ? (klevu_loginCustomerGroup = document.getElementById('klevu_loginCustomerGroup')
                    .innerText)
                : 'undefined' == typeof klevu_loginCustomerGroup && (klevu_loginCustomerGroup = ''),
                k = 0,
                a = (s = t.groupPrices.split(';')).length;
              k < a;
              k++
            )
              (i = s[k].split(':'))[0].trim() === klevu_loginCustomerGroup &&
                3 === i.length &&
                Number(i[2].trim()) < Number(t.salePrice) &&
                (r = i[2].trim())
          ;(u = Number(r).formatMoneyForKlevu(
            d.decimalPlaces,
            '',
            d.thousandSeparator,
            d.decimalSeparator
          )),
            (c =
              '<span class="money">' +
              (c = klevu_commons.addCurrencyToPrice(u, t.currency, o)) +
              '</span>'),
            'SLIM' === e
              ? (v += klevu_layout.getPriceDivs('SALE', c, '', l))
              : 'BASIC' === e
              ? (v += klevu_layout.getPriceDivs('SALE', c, '', l))
              : 'LANDING' === e && (v += klevu_getPriceDivs('SALE', c, '', l))
        } else if (
          t.salePrice.trim().length > 0 &&
          0 === t.priceToDisplay.trim().length &&
          '0.00' !== t.salePrice &&
          '0' !== t.salePrice &&
          '0.0' !== t.salePrice
        ) {
          if (((r = t.salePrice), t.groupPrices.trim().length > 0))
            for (
              document.getElementById('klevu_loginCustomerGroup')
                ? (klevu_loginCustomerGroup = document.getElementById('klevu_loginCustomerGroup')
                    .innerText)
                : 'undefined' == typeof klevu_loginCustomerGroup && (klevu_loginCustomerGroup = ''),
                k = 0,
                a = (s = t.groupPrices.split(';')).length;
              k < a;
              k++
            )
              (i = s[k].split(':'))[0].trim() === klevu_loginCustomerGroup &&
                3 === i.length &&
                Number(i[2].trim()) < Number(t.salePrice) &&
                (r = i[2].trim())
          ;(u = Number(r).formatMoneyForKlevu(
            d.decimalPlaces,
            '',
            d.thousandSeparator,
            d.decimalSeparator
          )),
            (c =
              '<span class="money">' +
              (c = klevu_commons.addCurrencyToPrice(
                // Price
                t.currency === 'RP ' || t.currency === 'HK$' || 'TWD' || '$'
                  ? u.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  : u,
                // Currency symbol
                t.currency === 'THB'
                  ? '฿'
                  : t.currency === 'MOP'
                  ? 'MOP$'
                  : t.currency === 'RP '
                  ? ''
                  : t.currency === 'HK$'
                  ? '$'
                  : t.currency === 'TWD'
                  ? '$'
                  : t.currency,
                // Currency symbol position - True = after
                t.currency === 'THB' ? true : t.currency === '&euro;' ? false : o
              )) +
              '</span>'),
            'SLIM' === e
              ? (v = klevu_layout.getPriceDivs('SALE', c, '', l))
              : 'BASIC' === e
              ? (v = klevu_layout.getPriceDivs('SALE', c, '', l))
              : 'LANDING' === e && (v = klevu_getPriceDivs('SALE', c, '', l))
        }
      if (
        (t.priceToDisplay.trim().length > 0 &&
          ('SLIM' === e
            ? (v += klevu_layout.getPriceDivs('SALE', t.priceToDisplay, '', l))
            : 'BASIC' === e
            ? (v += klevu_layout.getPriceDivs('SALE', t.priceToDisplay, '', l))
            : 'LANDING' === e && (v += klevu_getPriceDivs('SALE', t.priceToDisplay, '', l))),
        t.startPrice.trim().length > 0 &&
          t.totalProductVariants &&
          '0' != t.totalProductVariants &&
          '0.00' !=
            (u = Number(t.startPrice).formatMoneyForKlevu(
              d.decimalPlaces,
              '',
              d.thousandSeparator,
              d.decimalSeparator
            )) &&
          ((showToLabel = !0),
          (c =
            '<span class="money">' +
            (c = klevu_commons.addCurrencyToPrice(u, t.currency, o)) +
            '</span>'),
          'SLIM' === e
            ? (v += klevu_layout.getPriceDivs('SALE', c, '', l))
            : 'BASIC' === e
            ? (v += klevu_layout.getPriceDivs('SALE', c, '', l))
            : 'LANDING' === e && (v += klevu_getPriceDivs('SALE', c, '', l))),
        -1 !== v.indexOf('class="klevu-saleprice-l2"'))
      ) {
        var p = 'class="klevu-saleprice-l2"'
        v = v.replace('class="klevu-saleprice-l2"', p)
        v = v.replace('.00', '')
      }
      if (-1 !== v.indexOf('class="kuSalePrice"')) {
        var y = 'class="kuSalePrice"'
        v = v.replace('class="kuSalePrice"', y)
        v = v.replace('.00', '')
      }
      return v
    },
    showLandingPageNoResultData: function (e) {
      var t,
        l = '',
        n = e.products || [],
        r = klevu_userOptions.noResultsOptions,
        a = !1,
        i = document.createElement('div')
      if (
        ((l += '<div class="kuNoResults-lp">'),
        (l += '<div class="kuNoResultsInner">'),
        (l +=
          '<div class="kuNoResults-lp-message" aria-live="assertive" role="status" tabindex="0">' +
          e.msgToShow +
          '</div>'),
        n && n.length > 0)
      ) {
        var s = 'undefined' != typeof klevu_lang && '' !== klevu_lang ? klevu_lang : 'en'
        ;(l += '<div class="kuNoResults-lp-relatedProducts">'),
          (l += '<h3 class="kuNoResults-lp-title">' + ku_translations[s].youMayAlsoLike + '</h3>'),
          (l += '<ul class="kuNoResults-lp-relatedProduct-list">')
        for (var o = 0; o < n.length; o++)
          (l += '<li>'),
            (l += '<a href="' + n[o].url + '" class="kuRelatedProductbox-lp"'),
            klevu_commons.isMobileDevice()
              ? (l +=
                  ' onclick="return  klevu_analytics.trackClickedProduct(event, ' +
                  e.trackingParams[o] +
                  ');" target="_self" >')
              : (l +=
                  ' onmousedown="return  klevu_analytics.trackClickedProduct(event, ' +
                  e.trackingParams[o] +
                  ');"  onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
                  e.trackingParams[o] +
                  ', klevu_analytics.trackClickedProduct);" ' +
                  e.additionalParams +
                  ' >'),
            ('undefined' == typeof klevu_truncateDescription ||
              ('undefined' != typeof klevu_truncateDescription && klevu_truncateDescription)) &&
              n[o].desc.length > 33 &&
              (n[o].desc = n[o].desc.replace(/^(.{33}[^\s]*).*/, '$1') + ' ...'),
            (i.innerHTML = n[o].name),
            (t = i.textContent || i.innerText || ''),
            (l += '<div class="kuNoResultsImgWrap-lp">'),
            (l +=
              '<img src="' +
              n[o].imageUrl +
              '" onerror="this.onerror=null;this.src=\'' +
              klevu_userOptions.noImageUrl +
              '\';" alt="' +
              klevu_commons.escapeHtml(t) +
              '"/></div>'),
            (l += '<div class="kuProduct-desc">'),
            (l += '<div class="ku-name">' + n[o].name + '</div>'),
            (l += '<div class="ku-desc">' + n[o].desc + '</div>'),
            (l += '</div>'),
            void 0 !== n[o].storeBaseCurrency && (n[o].currency = n[o].storeBaseCurrency),
            klevu_showPrices &&
              ((l += '<div class="kuPrice">'),
              klevu_userOptions.showOnlyOriginalAndSalePrices
                ? (l += klevu_commons.showOriginalAndSalePrices(
                    'LANDING',
                    n[o],
                    'kuSalePrice',
                    'kuSalePrice kuSpecialPrice'
                  ))
                : (l += klevu_commons.showProductPrices(
                    'LANDING',
                    n[o],
                    'kuSalePrice',
                    'kuSalePrice kuSpecialPrice'
                  )),
              (l += '</div>')),
            n[o].totalProductVariants &&
              '0' != n[o].totalProductVariants &&
              (l +=
                '<div class="kuVariants">+' +
                n[o].totalProductVariants +
                ' ' +
                klevu_uiLabels.variants +
                '</div>'),
            (l += '<div class="klevu-clear-left"></div>'),
            (l += '</a> </li>')
        ;(l += '</ul>'), (l += '</div>')
      }
      if (
        (e.banner &&
          e.banner.showOnLandingPage &&
          ((trackingParams =
            "{id: '" +
            e.banner.bannerRef +
            "',name: '" +
            e.banner.bannerName +
            "',image: '" +
            escape(e.banner.bannerImageUrl) +
            "',redirectUrl: '" +
            e.banner.redirectUrl +
            "'}"),
          klevu_commons.isMobileDevice()
            ? (trackingEvent = ' onclick=')
            : (trackingEvent =
                ' onclick="klevu_analytics.stopClickDefault( event );"  onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
                trackingParams +
                ', klevu_analytics.trackClickedBannerAds);"  onmousedown='),
          (trackingEvent +=
            '"return klevu_analytics.trackClickedBannerAds(event, ' +
            trackingParams +
            ');" target="_blank">'),
          (l +=
            '<div class="kuNoResults-lp-banner"><a href="' +
            e.banner.redirectUrl +
            '" ' +
            trackingEvent +
            '<img src="' +
            e.banner.bannerImageUrl +
            '" alt="' +
            e.banner.bannerName +
            '"/></a></div>')),
        ((r && r.showPopularKeywords) || klevu_userOptions.showPopularKeywordsForNoResult) &&
          (a = !0),
        'undefined' != typeof klevu_webstorePopularTerms && klevu_webstorePopularTerms && a)
      ) {
        var u = klevu_webstorePopularTerms,
          c = 1
        if (
          ((l += '<div class="kuNoResults-lp-pSearch">'),
          (l +=
            '<strong class="kuNoResults-lp-pSearch-title">' +
            klevu_uiLabels.popularSearches +
            ' </strong>'),
          u && u.length > 0)
        )
          for (o = 0; o < u.length; o++) {
            0 !== o && (l += ', ')
            try {
              l +=
                '<a href="' +
                e.landingPageUrl +
                encodeURIComponent(decodeURIComponent(u[o])) +
                '" target="_self">' +
                decodeURIComponent(u[o]) +
                '</a>'
            } catch (e) {
              continue
            }
            if (5 === c) break
            c++
          }
        l += '</div>'
      }
      return (l += '</div>'), (l += '</div>')
    },
    showResultsData: function (e) {
      var t = document,
        l = !0,
        n = t.getElementById('klevuSearchNoResults'),
        r = t.getElementById('klevuArrow'),
        a = t.getElementById('klevu-pt-rs-hover')
      if ((this.hideLoader(), 0 !== klevu_searchedTerm.length)) {
        a && (a.style.display = 'none'),
          n && (n.style.display = 'none'),
          klevu_showAdvancedAutosuggestionLayout
            ? this.showAdvancedAutoSuggestions(e.autoComplete, l, e.meta)
            : (this.showAutoSuggestions(e.autoComplete, e.meta),
              klevu_uc.showCmsContent(e.pages),
              this.showCategories(e.categories),
              ((e.autoComplete && e.autoComplete.length > 0) ||
                (e.categories && e.categories.length > 0) ||
                (e.pages && e.pages.length > 0)) &&
                (l = !1),
              klevu_uc.showProducts(e.meta, e.result, l, e.popularProducts),
              !l || e.result.length > 0
                ? klevu_commons.showBannerAdForGivenTerm(klevu_searchedTerm)
                : klevu_commons.showBannerAdForGivenTerm('')),
          (t.getElementById('klevuSearchingArea').style.cssText += ';display : block !important;'),
          r && (r.style.display = 'none')
        var i = 'undefined' != typeof klevu_lang && '' !== klevu_lang ? klevu_lang : 'en'
        uc_helperFunctions.ifNoResults(e.result.length, 'klevuResultsBlock-noResults'),
          e.result.length <= 0
            ? document.getElementById('klevuProductHeading') &&
              ((document.getElementById('klevuProductHeading').style.display = 'flex'),
              document.querySelector('.ku-noProducts') ||
                document
                  .getElementById('klevuProductHeading')
                  .insertAdjacentHTML(
                    'afterend',
                    '<div class="ku-noProducts">' + ku_translations[i].noProducts + '</div>'
                  ))
            : document.querySelector('.ku-noProducts') &&
              document.querySelector('.ku-noProducts').remove(),
          uc_helperFunctions.ifNoResults(e.pages.length, 'klevuCmsContentArea-noResults'),
          e.pages.length <= 0 && document.getElementById('klevuCmsContentArea')
            ? ((document.getElementById('klevuCmsContentArea').style.display = 'block'),
              document.querySelector('#klevuCmsContentArea .klevuSuggestionHeading') &&
                (document.querySelector('.ku-noCMS') ||
                  document
                    .querySelector('#klevuCmsContentArea .klevuSuggestionHeading')
                    .insertAdjacentHTML(
                      'afterend',
                      '<div class="ku-noCMS">' + ku_translations[i].noCMS + '</div>'
                    )))
            : document.querySelector('.ku-noCMS') && document.querySelector('.ku-noCMS').remove(),
          uc_helperFunctions.ifNoResults(e.autoComplete.length, 'klevuAutoCompleteArea-noResults'),
          uc_helperFunctions.ifNoResults(e.categories.length, 'klevuCategoryArea-noResults')
      }
    },
    showProducts: function (e, t, l, n) {
      var r,
        a,
        i,
        s = document,
        o = '',
        u = klevu_userOptions.recordsPerPage,
        c = 0,
        d = s.getElementById('productsList'),
        v = '',
        k = '',
        m = '',
        g = '',
        p = '',
        y = '',
        h = '',
        _ = '',
        f = '',
        P = '',
        S = '',
        b = '',
        F = '',
        C = '',
        w = '',
        E = '',
        L = '',
        T = s.getElementById('klevuProductHeading'),
        B = '',
        I = '',
        A = 0,
        N = s.createElement('div'),
        x = klevu_commons.getRedirectUrlForSearchedTerm(klevu_searchedTerm)
      if (
        ('undefined' != typeof klevu_storeLandingPageUrl && (B = klevu_storeLandingPageUrl),
        (B =
          'undefined' != typeof klevu_searchQueryParam && klevu_searchQueryParam
            ? klevu_commons.updateUrlParameter(B, klevu_searchQueryParam, '')
            : klevu_commons.updateUrlParameter(B, 'q', '')),
        null !== x ? (B = x) : (B += encodeURIComponent(klevu_searchedTerm)),
        t.length > 0)
      ) {
        var R = 'undefined' != typeof klevu_lang && '' !== klevu_lang ? klevu_lang : 'en'
        for (
          T.innerHTML =
            '<span class="klevuHeadingText">' + ku_translations[R].ProductResults + '</span>',
            I = '<a href="' + B + '" target="_parent">' + ku_translations[R].viewAll + '</a>',
            klevu_layout.loaderPlaced
              ? (T.innerHTML += I)
              : (T.innerHTML += '<span class="klevuLoader" id="klevu-loader-2">' + I + '</span>'),
            T.style.display = 'flex',
            o = '<ul>',
            c = 0;
          c < t.length && c < u;
          c++
        ) {
          for (i in ((k = t[c].name || ''),
          (v = t[c].shortDescription || t[c].shortDesc || t[c].desc || t[c].metaDesc || ''),
          (m = t[c].brand || ''),
          (g = t[c].id || ''),
          (p = t[c].salePrice || ''),
          (h = t[c].price || ''),
          (_ = t[c].imageUrl || t[c].image || ''),
          (f = t[c].currency || ''),
          (S = t[c].displayPrice || ''),
          (b = t[c].totalVariants || ''),
          (F = t[c].url || ''),
          (w = t[c].startPrice || ''),
          (E = t[c].toPrice || ''),
          (L = t[c].sku || ''),
          (y = t[c].groupPrices || ''),
          (P = t[c].rating || ''),
          (C = t[c].discount || ''),
          (a = null),
          (i = null),
          (A = 1 + c),
          (N.innerHTML = v),
          (v = N.textContent || N.innerText || '').length > 33 &&
            (v = v.replace(/^(.{33}[^\s]*).*/, '$1') + ' ...'),
          (r = v.lastIndexOf('<b')) > v.lastIndexOf('</b>') && (v = v.substring(0, r - 1)),
          (a = {
            productCode: g,
            productImage: _,
            productBrand: m,
            productUrl: F,
            productName: k.split('|')[0].replace('·', '<br />'),
            productDescription: v,
            productPrice: h,
            salePrice: p,
            currency: f,
            priceToDisplay: S,
            startPrice: w,
            toPrice: E,
            totalProductVariants: b,
            productSku: L,
            groupPrices: y,
            rating: P,
            discount: C,
            productPosition: A
          }),
          t[c]))
            t[c].hasOwnProperty(i) && (a[i] = t[c][i])
          ;(o += klevu_layout.displayProductdata(a)), (N.innerHTML = '')
        }
        ;(o += '</ul>'), (d.innerHTML = o)
      } else if (((T.style.display = 'none'), (d.innerHTML = ''), l)) {
        var O = s.getElementById('klevuSearchNoResults')
        ;(O.innerHTML = klevu_layout.displayNoResultData(
          klevu_commons.getNoResultsData(klevu_uiLabels.noRecords, n)
        )),
          (O.style.display = 'block')
      }
      d.style.display = 'block'
    },
    showCmsContent: function (e) {
      var t = document.getElementById('klevuCmsContentArea'),
        l = 2,
        n = '',
        r = '',
        a = 0
      if (
        ('undefined' != typeof klevu_maxPagesToShow &&
          klevu_maxPagesToShow &&
          (l = klevu_maxPagesToShow),
        'undefined' != typeof klevu_storeLandingPageUrl && (r = klevu_storeLandingPageUrl),
        (r =
          'undefined' != typeof klevu_searchQueryParam && klevu_searchQueryParam
            ? klevu_commons.updateUrlParameter(r, klevu_searchQueryParam, '')
            : klevu_commons.updateUrlParameter(r, 'q', '')),
        (r += encodeURIComponent(klevu_searchedTerm) + '&goToCMS=true'),
        e && e.length > 0)
      ) {
        var i = 'undefined' != typeof klevu_lang && '' !== klevu_lang ? klevu_lang : 'en'
        for (
          n =
            '<div class="klevuSuggestionHeading"><span class="klevuHeadingText">' +
            ku_translations[i].articles +
            '</span><a href="' +
            r +
            '">' +
            ku_translations[i].viewAll +
            '</a>',
            klevu_layout.loaderPlaced ||
              ((n += '<span class="klevuLoader" id="klevu-loader-2"></span>'),
              (klevu_layout.loaderPlaced = !0)),
            n += '</div>',
            n += '<ul>',
            a = 0;
          a < e.length && a < l;
          a++
        ) {
          var s = e[a].imageUrl
            ? e[a].imageUrl
            : e[a].image
            ? e[a].image
            : klevu_userOptions.noImageUrl
          n += '<li>\n<a href="'
            .concat(
              e[a].url,
              '" target="_self" class="ku-cms-link">\n<div class="ku-img-wrap">\n<img src="'
            )
            .concat(s, '" alt="')
            .concat(e[a].name, '"/>\n</div>\n<div class="ku-cms-name">\n')
            .concat(e[a].name, '\n</div>\n</a>\n</li>')
        }
        ;(n += '</ul>'), (t.innerHTML = n), (t.style.display = 'block')
      } else t.style.display = 'none'
    },
    addAutocompleteLayoutToPage: function (e) {
      var t, l, n, r, a, i, s, o, u, c
      if (
        (klevu_fluidLayoutEnabled
          ? ((r = this.addElementToParent(e, 'div', {
              class: 'klevu-fluid',
              role: 'region',
              'aria-label': 'Klevu Search Container'
            })),
            'undefined' != typeof klevu_bigCommerceStore &&
              klevu_bigCommerceStore &&
              r.setAttribute('data-prevent-quick-search-close', ''))
          : (r = e),
        (loaderContainerDiv = this.addElementToParent(r, 'div', {
          class: 'klevu-searching-area-l2',
          id: 'loaderContainer',
          style: 'display:none;'
        })),
        this.addLoaderDiv(loaderContainerDiv),
        this.addElementToParent(r, 'div', {
          class: 'klevu-arrow',
          id: 'klevuArrow',
          style: 'display:none;'
        }),
        (t = this.addElementToParent(r, 'div', {
          class: 'klevu-searching-area-l2',
          id: 'klevuSearchingArea',
          style: 'display:none;',
          tabindex: '-1'
        })),
        klevu_showPopularSearches ||
          klevu_showRecentSerches ||
          klevu_userOptions.showRecentlyViewedItems ||
          klevu_userOptions.showTrendingProducts)
      ) {
        ;(a = document.createElement('div')).setAttribute('class', 'klevu-pt-rs-hover'),
          a.setAttribute('id', 'klevu-pt-rs-hover'),
          a.setAttribute('tabindex', '-1'),
          (a.style.display = 'none'),
          klevu_fluidLayoutEnabled
            ? ((i = document.createElement('div')).setAttribute('class', 'klevu-fluid'),
              i.setAttribute('role', 'region'),
              i.setAttribute('aria-label', 'Klevu Personalisation Container'),
              i.appendChild(a),
              e.appendChild(i))
            : e.appendChild(a)
        var d = !1
        klevu_showPopularSearches && (d = this.addPopularSearchesDiv(a)),
          klevu_showRecentSerches && (d = this.addRecentSearchesDiv(a)),
          d || (a.style.display = 'none')
      }
      var v = this.addElementToParent(t, 'div', { class: 'ku-searchWrap' })
      if (
        (this.addElementToParent(v, 'div', {
          class: 'klevuNoResults klevuNoResults-new',
          id: 'klevuSearchNoResults',
          style: 'display:none;'
        }),
        screenWidthCheck())
      ) {
        ;(s = this.addElementToParent(v, 'div', {
          class: 'klevuSuggestionsBlock',
          id: 'klevuSuggestionsBlock'
        })),
          this.addElementToParent(s, 'div', {
            class: 'klevuAutoSuggestion-l2',
            id: 'klevuAutoCompleteArea',
            style: 'display:none;'
          }),
          (o = this.addElementToParent(v, 'div', {
            class: 'klevuResultsBlock',
            id: 'klevuResultsBlock'
          })),
          this.addElementToParent(o, 'div', {
            class: 'klevuSuggestionHeading',
            id: 'klevuProductHeading',
            style: 'display:none;'
          }),
          this.addElementToParent(o, 'div', {
            class: 'klevuSearchResults-l2',
            id: 'productsList',
            style: 'display:none;'
          }),
          (l = this.addElementToParent(v, 'div', {
            class: 'klevuAutoSuggestion-l2',
            id: 'klevuCmsContentArea',
            style: 'display:none;'
          }))
        var k = 'undefined' != typeof klevu_lang && '' !== klevu_lang ? klevu_lang : 'en'
        ;((n = this.addElementToParent(l, 'div', {
          class: 'klevuSuggestionHeading',
          style: 'display:none;'
        })).innerHTML =
          '<span class="klevuHeadingText">' + ku_translations[k].articles + '</span>'),
          'undefined' != typeof klevu_showBannerAds &&
            klevu_showBannerAds &&
            this.addElementToParent(v, 'div', {
              class: 'klevu-banner-ad',
              id: 'klevuBannerAdTop',
              style: 'padding:0px;'
            }),
          this.addElementToParent(v, 'div', {
            class: 'klevuAutoSuggestion-l2',
            id: 'klevuCategoryArea',
            style: 'display:none;'
          })
      } else {
        ;(l = this.addElementToParent(v, 'div', {
          class: 'klevuAutoSuggestion-l2',
          id: 'klevuCmsContentArea',
          style: 'display:none;'
        })),
          (n = this.addElementToParent(l, 'div', {
            class: 'klevuSuggestionHeading',
            style: 'display:none;'
          }))
        k = 'undefined' != typeof klevu_lang && '' !== klevu_lang ? klevu_lang : 'en'
        ;(n.innerHTML =
          '<span class="klevuHeadingText">' + ku_translations[k].articles + '</span>'),
          (o = this.addElementToParent(v, 'div', {
            class: 'klevuResultsBlock',
            id: 'klevuResultsBlock'
          })),
          this.addElementToParent(o, 'div', {
            class: 'klevuSuggestionHeading',
            id: 'klevuProductHeading',
            style: 'display:none;'
          }),
          this.addElementToParent(o, 'div', {
            class: 'klevuSearchResults-l2',
            id: 'productsList',
            style: 'display:none;'
          }),
          'undefined' != typeof klevu_showBannerAds &&
            klevu_showBannerAds &&
            this.addElementToParent(v, 'div', {
              class: 'klevu-banner-ad',
              id: 'klevuBannerAdTop',
              style: 'padding:0px;'
            })
        var m = this.addElementToParent(v, 'div', { class: 'suggestionsWrapperBlock' })
        ;(s = this.addElementToParent(m, 'div', {
          class: 'klevuSuggestionsBlock',
          id: 'klevuSuggestionsBlock'
        })),
          this.addElementToParent(s, 'div', {
            class: 'klevuAutoSuggestion-l2',
            id: 'klevuAutoCompleteArea',
            style: 'display:none;'
          }),
          this.addElementToParent(m, 'div', {
            class: 'klevuAutoSuggestion-l2',
            id: 'klevuCategoryArea',
            style: 'display:none;'
          })
      }
      ;(this.addElementToParent(v, 'div', { class: 'ku-close-search' }).innerHTML =
        '<div onclick="uc_helperFunctions.closeQuickSearch()"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20"><path d="M11.59 10L19 2.59 17.41 1 10 8.41 2.59 1 1 2.59 8.41 10 1 17.41 2.59 19 10 11.59 17.41 19 19 17.41z"/></svg></div>'),
        'undefined' != typeof klevu_showBannerAds &&
          klevu_showBannerAds &&
          this.addElementToParent(v, 'div', {
            class: 'klevu-banner-ad',
            id: 'klevuBannerAdBottom',
            style: 'padding:0px;'
          }),
        klevu_logoFreeSearch || this.addPoweredByDiv(v),
        klevu_fluidLayoutEnabled ? ((c = r), (u = i)) : ((c = v), (u = a)),
        this.addElementToParent(c, 'div', {
          onkeydown: 'klevu_commons.setupNextTabForLastChild();',
          tabindex: '0'
        }),
        (klevu_showPopularSearches ||
          klevu_showRecentSerches ||
          klevu_userOptions.showRecentlyViewedItems ||
          klevu_userOptions.showTrendingProducts) &&
          this.addElementToParent(u, 'div', {
            onkeydown: 'klevu_commons.setupNextTabForLastChild();',
            tabindex: '0'
          })
    },
    landingFilters: {
      loadingFiltersFor: 'search-query',
      lastSelectedFilters: '',
      showFilters: function (e) {
        var t,
          l,
          n = document.getElementById('kuFilters'),
          r = 0,
          a = 0,
          i = new Array(),
          s = '',
          o = klevu_commons.isMobileDevice()
            ? document.getElementById('kuFilterRefineMobile')
            : document.getElementById('klevuNarrowByLabel')
        if (
          ((klevuLandingFilterTxt = ''),
          (n.innerHTML = ''),
          'undefined' != typeof klevu_multiSelectFilters &&
            klevu_multiSelectFilters &&
            (s = ' kuMulticheck'),
          e && e.length > 0)
        ) {
          for (n.className = 'kuFilters' + s, t = 0, l = e.length; t < l; t++)
            ('Price Range' !== e[t].key || klevu_showPrices) &&
              ((i[r] = klevu_landingFilters.displayFiltersData(e[t])), r++)
          for (
            n.innerHTML = klevuLandingFilterTxt,
              void 0 !== o &&
                o &&
                (0 === klevuLandingFilterTxt.trim().length
                  ? (o.style.display = 'none')
                  : (o.style.display = 'block')),
              t = 0,
              l = i.length;
            t < l;
            t++
          )
            i[t] && '' != i[t].trim() && (document.getElementById(i[t]).style.height = 'auto')
          for (r = 0, a = 0, l = e.length; a < l; a++) {
            var u = e[a].key.replace(' ', '_'),
              c = e[a].options
            for (t = 0; t < c.length; t++) {
              var d = t + u + '~text'
              'true' === c[t].isSelected.trim() &&
                (klevu_landingFilters.showSelectedFilter(d, c[t].name, r, e[a].label), r++)
            }
          }
          'undefined' != typeof klevu_showPriceSlider &&
            klevu_showPriceSlider &&
            -1 !== klevu_userOptions.selectedLandingFilters.indexOf('klevu_price') &&
            (klevu_landingFilters.showSelectedFilter(
              null,
              klevu_userOptions.selectedLandingFilters.match(/klevu_price:[0-9.\- ]*;*/)[0],
              r,
              null,
              'Price-Range'
            ),
            r++),
            0 === r && klevu_landingFilters.showSelectedFilter(null, null, -1),
            (n.style.display = 'none'),
            n.offsetHeight,
            (n.style.display = 'block'),
            document.getElementById('kuFilterRefineMobile') &&
              klevu_commons.isMobileDevice() &&
              (!klevu_userOptions.checkScreenSizeForShowingFiltersInMobile || screen.width < 768) &&
              (klevu_landingFilters.lastSelectedFilters === klevu_userOptions.selectedLandingFilters
                ? klevu_landingFilters.showFiltersOnMobile(!1)
                : klevu_landingFilters.showFiltersOnMobile(!(0 === r)),
              (klevu_landingFilters.lastSelectedFilters = klevu_userOptions.selectedLandingFilters))
        } else n.className = 'kuFilters disableKuFilter' + s
      },
      displayFiltersData: function (e) {
        if (e) {
          var t,
            l,
            n = klevu_translateFilterLabel(e.label),
            r = !1,
            a = '',
            i = e.options,
            s = e.key.replace(' ', '_'),
            o = !1,
            u = 'kuHover'
          ;(klevu_userOptions.truncateFilterLabel = !1),
            'price range' === e.label.toLowerCase() && (r = !0),
            'MSRP' === e.label && !0,
            'inStock' === e.key && !0,
            klevu_commons.isMobileDevice() && (u = ''),
            i.length > 6
              ? (a += '<div class="kuFilterBox ' + u + '" id="kuFilterBox-' + s + '">')
              : (a +=
                  '<div class="kuFilterBox ' +
                  u +
                  '" style="height:auto;" id="kuFilterBox-' +
                  s +
                  '">')
          var c = []
          i.forEach(function (e) {
            'true' === e.isSelected && c.push(e.name)
          }),
            c.length > 0 && screenWidthCheck()
              ? (a += '<div class="kuFilterHead kuCollapse" id="kuFilterHead-'
                  .concat(
                    s,
                    '" \n            onclick="klevu_landingFilters.collapseExpand(\'kuFilterHead-'
                  )
                  .concat(s, "', 'kuFilterNames-")
                  .concat(s, "', 'kuShowOpt-")
                  .concat(s, "', 'kuHideOpt-")
                  .concat(s, "', 'kuFilterBox-")
                  .concat(s, '\' );">\n            <span>')
                  .concat(n, '</span> <span class="ku-selectedFacets">')
                  .concat(
                    c.join(', '),
                    '</span>\n            </div>\n            <div class="kuFilterNames" id="kuFilterNames-'
                  )
                  .concat(s, '"><ul>'))
              : (a += '<div class="kuFilterHead kuCollapse" id="kuFilterHead-'
                  .concat(
                    s,
                    '" \n            onclick="klevu_landingFilters.collapseExpand(\'kuFilterHead-'
                  )
                  .concat(s, "', 'kuFilterNames-")
                  .concat(s, "', 'kuShowOpt-")
                  .concat(s, "', 'kuHideOpt-")
                  .concat(s, "', 'kuFilterBox-")
                  .concat(s, '\' );">\n            ')
                  .concat(
                    n,
                    '\n            </div>\n            <div class="kuFilterNames" id="kuFilterNames-'
                  )
                  .concat(s, '"><ul>'))
          for (var d = 0, v = i.length; d < v; d++) {
            var k = i[d].isSelected,
              m = d + s + '~text',
              g = '',
              p = 'kuFilterTotal',
              y = i[d].count,
              h = "klevu_landingFilters.sendQuery('" + m + "', true );"
            if (
              ('true' === k.trim() &&
                ((g = 'kuSelected'),
                (p = 'kuFilterCancel'),
                'undefined' != typeof klevu_multiSelectFilters && klevu_multiSelectFilters
                  ? ((y = i[d].count), (o = !0))
                  : (y = 'X'),
                (h = "klevu_landingFilters.cancelFilter('" + m + "'); ")),
              (t = i[d].name),
              r)
            ) {
              t = klevu_commons.replaceCurrencyWithItsSymbol(t, klevu_storeLandingCurrency)
              try {
                var _ = t.split('-').map(function (e) {
                  return e.trunc(), '<span class="money">'.concat(e, '</span>')
                })
                t = _.join(' - ')
              } catch (e) {
                console.log(e)
              }
              ;(l = t), (t = '')
            } else l = klevu_userOptions.truncateFilterLabel ? t.trunc(18) : t
            a +=
              '<li id="' +
              d +
              s +
              '" class="' +
              g +
              '"><a href="javascript:void(0);" onclick="' +
              h +
              '" title="' +
              t +
              '" target="_self"><span class="kuFilterLabel">' +
              l +
              '</span><span class="' +
              p +
              '">(' +
              y +
              ')</span></a></li><input type="hidden" id="' +
              m +
              '" value="' +
              klevu_commons.escapeHtml(i[d].value) +
              '"/>'
          }
          if (
            ((a += '<button class="ku-clear-facet">Clear</button></ul></div></div>'),
            i.length > 6 &&
              (o
                ? (a = a.replace(
                    '<div class="kuFilterBox ' + u + '" id="kuFilterBox-' + s + '">',
                    '<div class="kuFilterBox ' +
                      u +
                      '" style="height:auto;" id="kuFilterBox-' +
                      s +
                      '">'
                  ))
                : (a +=
                    '<div class="kuShowOpt" id="kuShowOpt-' +
                    s +
                    '" style="display:block;text-align:center;"><a href="javascript:klevu_landingFilters.showAll( \'kuFilterBox-' +
                    s +
                    '\' );" title="' +
                    klevu_uiLabels.showMore +
                    '" target="_self"><img src="' +
                    klevu_userOptions.viewMoreImageUrl +
                    '" alt="' +
                    klevu_uiLabels.showMore +
                    '"/></a></div><div class="kuHideOpt" id="kuHideOpt-' +
                    s +
                    '" style="display:none;text-align:center;"><a href="javascript:void(0);" onclick="klevu_landingFilters.hideAll(\'kuFilterBox-' +
                    s +
                    '\');" title="' +
                    klevu_uiLabels.showLess +
                    '" target="_self"><img src="' +
                    klevu_userOptions.viewLessImageUrl +
                    '" alt="' +
                    klevu_uiLabels.showLess +
                    '"/></a></div>')),
            (klevuLandingFilterTxt += a),
            i.length > 0 && i.length < 6)
          )
            return 'kuFilterBox-' + s
        }
      },
      displayPricingSlider: function () {
        var e = klevu_translateFilterLabel('PRICE RANGE').toUpperCase(),
          t = '',
          l = 'Price-Range',
          n = 'klevuPriceRangeSlider'
        return (
          (t +=
            (1).length > 6
              ? '<div class="kuFilterBox" id="kuFilterBox-' + l + '">'
              : '<div class="kuFilterBox" style="height:auto;" id="kuFilterBox-' + l + '">'),
          (t +=
            '<div class="kuFilterHead kuCollapse" id="kuFilterHead-' +
            l +
            '" onclick="klevu_landingFilters.collapseExpand( \'kuFilterHead-' +
            l +
            "', 'kuFilterNames-" +
            l +
            "', 'kuShowOpt-" +
            l +
            "', 'kuHideOpt-" +
            l +
            "', 'kuFilterBox-" +
            l +
            '\' );">' +
            e +
            '</div><div class="kuFilterNames" id="kuFilterNames-' +
            l +
            '">'),
          'undefined' != typeof klevu_current_version &&
            klevu_current_version &&
            ((klevuPluginVersion = klevu_commons.compareVersionNumbers(
              klevu_current_version,
              '2.0.2'
            )),
            !isNaN(klevuPluginVersion) && klevuPluginVersion >= 0 && (n = 'kuPriceRangeSlider'),
            (klevuPluginVersion = klevu_commons.compareVersionNumbers(
              klevu_current_version,
              '2.0.0'
            )),
            !isNaN(klevuPluginVersion) &&
              klevuPluginVersion < 0 &&
              ((klevuPluginVersion = klevu_commons.compareVersionNumbers(
                klevu_current_version,
                '1.2.5'
              )),
              !isNaN(klevuPluginVersion) && klevuPluginVersion >= 0 && (n = 'kuPriceRangeSlider'))),
          'undefined' != typeof klevu_shopifyStore &&
            klevu_shopifyStore &&
            (n = 'kuPriceRangeSlider'),
          (t += '<div class="' + n + '"><div id="ku-price-range"></div>'),
          (t +=
            '<div > <span id="ku-from-price"></span>&nbsp; <span id="ku-to-price"></span></div></div>'),
          (t += '</div></div>')
        )
      },
      sendQuery: function (e, t) {
        var l,
          n,
          r = document,
          a = '',
          i = '',
          s = (r.getElementById('kuFilters'), '')
        t && (r.getElementById(e.split('~')[0]).className = 'kuSelected'),
          'undefined' != typeof klevu_userFilterResults && (i = klevu_userFilterResults),
          (l = '')
        for (var o = 0, u = (n = getElementsByClassName('kuSelected', 'li')).length; o < u; o++)
          (a = klevu_commons.unescapeHtml(r.getElementById(n[o].id + '~text').value)),
            -1 === i.indexOf(a) && ('' === l.trim() ? (l += a) : (l += ';;' + a))
        return (
          'undefined' != typeof klevu_showPriceSlider &&
            klevu_showPriceSlider &&
            -1 !== klevu_userOptions.selectedLandingFilters.indexOf('klevu_price') &&
            (s =
              ';;' + klevu_userOptions.selectedLandingFilters.match(/klevu_price:[0-9.\- ]*;*/)[0]),
          (klevu_userOptions.selectedLandingFilters = l + s),
          klevu_addSelectedFiltersToUrl &&
            klevu_commons.addSelectedFiltersToPageUrl(
              klevu_userOptions.selectedLandingFilters,
              klevu_productFilterParam
            ),
          (klevu_pagination.landingStartPosition = 0),
          ('undefined' != typeof klevu_multiSelectFilters && klevu_multiSelectFilters) ||
            (document.body.scrollTop = document.documentElement.scrollTop = 0),
          r.getElementById('kuProductContent') &&
            (r.getElementById('kuProductContent').style.opacity = '0.3'),
          (klevu_landingFilters.loadingFiltersFor = 'filter-selection'),
          klevu_search.fetchResults(r.getElementById('searchedKeyword').value, 'klp'),
          !1
        )
      },
      showAll: function (e, t) {
        var l = document,
          n = l.getElementById(e),
          r = e.substring(e.indexOf('-') + 1, e.length)
        ;(n.style.height = 'auto'),
          (n.style.overflow = 'visible'),
          (l.getElementById('kuShowOpt-' + r).style.display = 'none'),
          (l.getElementById('kuHideOpt-' + r).style.display = 'block')
      },
      hideAll: function (e) {
        var t = document,
          l = t.getElementById(e),
          n = e.substring(e.indexOf('-') + 1, e.length)
        ;(l.style.height = ''),
          (l.style.overflow = 'hidden'),
          (t.getElementById('kuShowOpt-' + n).style.display = 'block'),
          (t.getElementById('kuHideOpt-' + n).style.display = 'none')
      },
      showSelectedFilter: function (e, t, l, n, r) {
        var a = document,
          i = a.getElementById('ku-search-filter-tags'),
          s = (a.getElementById('kuClearAllFilters'), '')
        if (i) {
          if (-1 === l) return void (i.innerHTML = '')
          0 === l && (i.innerHTML = ''),
            n && (s = n + ' : '),
            void 0 !== _typeof(r) && 'Price-Range' === r
              ? a.getElementById('kuPriceRangeTag') ||
                ((t = t.split(':')[1]),
                (s = klevu_translateFilterLabel('PRICE RANGE').toUpperCase() + ' : '),
                (i.innerHTML +=
                  '<span class="ku-search-filter-tag" id="kuPriceRangeTag"> ' +
                  s +
                  t +
                  ' <a class="ku-search-filter-remove" onclick="klevu_landingFilters.cancelPriceSliderFilter(); " target="_self" href="#">x</a></span> '))
              : (i.innerHTML +=
                  '<a class="ku-search-filter-tag" onclick="klevu_landingFilters.cancelFilter(\'' +
                  e +
                  '\'); " target="_self" href="#"> ' +
                  t +
                  ' <span class="ku-search-filter-remove">x</span></a> '),
            a.getElementById('kuClearAllFilters') &&
              a
                .getElementById('kuClearAllFilters')
                .parentNode.removeChild(a.getElementById('kuClearAllFilters')),
            (i.innerHTML +=
              '<span class="ku-search-filter-remove-all" id="kuClearAllFilters" onclick="klevu_landingFilters.clearAllFilters(); " onkeydown="klevu_eventHandler.handleElementKeydownEvent(event, null, klevu_landingFilters.clearAllFilters);" tabindex="0"><a> ' +
              klevu_uiLabels.clearAll +
              '</a></span>')
        }
      },
      cancelFilter: function (e) {
        ;(document.getElementById(e.split('~')[0]).className = ''),
          klevu_landingFilters.sendQuery(e, !1)
      },
      cancelPriceSliderFilter: function () {
        ;(klevu_userOptions.selectedLandingFilters = klevu_userOptions.selectedLandingFilters.replace(
          /klevu_price:[0-9.\- ]*;*/,
          ''
        )),
          klevu_landingFilters.sendQuery('', !1)
      },
      clearAllFilters: function () {
        for (var e = getElementsByClassName('kuSelected', 'li'), t = 0, l = e.length; t < l; t++)
          e[t].className = ''
        document.getElementById('kuPriceRangeTag') &&
          (klevu_userOptions.selectedLandingFilters = klevu_userOptions.selectedLandingFilters.replace(
            /klevu_price:[0-9.\- ]*;*/,
            ''
          )),
          klevu_landingFilters.sendQuery('', !1)
      },
      collapseExpand: function (e, t, l, n, r) {
        var a = document,
          i = a.getElementById(e),
          s = a.getElementById(t),
          o = a.getElementById(l),
          u = a.getElementById(n),
          c = a.getElementById(r)
        ;-1 !== i.className.indexOf('kuCollapse')
          ? ((i.className = 'kuFilterHead kuExpand'),
            (s.style.display = 'none'),
            o && (o.style.display = 'none'),
            u && (u.style.display = 'none'),
            (klevu_landingFilters.filterHeight = c.style.height),
            (c.style.height = '50px'))
          : -1 !== i.className.indexOf('kuExpand') &&
            ((i.className = 'kuFilterHead kuCollapse'),
            (s.style.display = 'block'),
            o && (o.style.display = 'block'),
            u && (u.style.display = 'none'),
            o && u ? klevu_landingFilters.hideAll(r) : (c.style.height = 'auto'))
      },
      showFiltersOnMobile: function (e) {
        var t = document,
          l = t.getElementById('kuFilters'),
          n = t.getElementById('kuFilterRefineMobile')
        if (((e = void 0 === e || e), -1 !== n.className.indexOf('kuCollapse')))
          e
            ? ((n.className = 'kuFilterRefineMobile kuExpand'),
              (l.style.cssText += ';display : none !important;'))
            : (l.style.cssText += ';display : block !important;')
        else if (-1 !== n.className.indexOf('kuExpand')) {
          e
            ? ((n.className = 'kuFilterRefineMobile kuCollapse'),
              (l.style.cssText += ';display : block !important;'))
            : (l.style.cssText += ';display : none !important;')
          for (
            var r = getElementsByClassName('kuFilterHead', 'div'), a = 0, i = r.length;
            a < i;
            a++
          )
            -1 !== r[a].className.indexOf('kuCollapse') && r[a].click()
        }
      }
    },
    showLandingPageCmsData: function (e) {
      var t,
        l = '',
        n = '',
        r = document.getElementById('searchedKeyword').value
      ;(n = klevu_userOptions.openProductClicksInNewWindow
        ? ' target="_blank"'
        : ' onclick="klevu_analytics.stopClickDefault( event );"'),
        (t =
          "{data: {code: '" +
          escape(e.contentCode) +
          "',url: '" +
          escape(e.contentUrl) +
          "',name: '" +
          escape(e.contentTitle) +
          "',position: " +
          e.contentPosition +
          "},apiKey: '" +
          klevu_cmsApiKey +
          "',keywordsLP: '" +
          escape(r) +
          "',forCms: true}")
      var a = e.imageUrl ? e.imageUrl : e.image ? e.image : ''
      return (
        (l += '<li>'),
        (l += '<a class="art-Card" href="' + e.contentUrl + '" target="_blank" '),
        klevu_commons.isMobileDevice()
          ? (l += ' onclick="return klevu_analytics.trackClickedProduct(event, ' + t + ');" >')
          : (l +=
              ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' +
              t +
              ');" onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
              t +
              ', klevu_analytics.trackClickedProduct);" ' +
              n +
              '>'),
        (l += '<div class="art-Card_ImageContainer">'),
        (l += '<div class="art-Card_Image">'),
        console.log(this.onerror),
        (l +=
          '<img src="' +
          a +
          '" onerror="this.onerror=null;this.src=\'' +
          klevu_userOptions.noImageUrl +
          '\';" alt="' +
          klevu_commons.escapeHtml(e.contentTitle) +
          '"/>'),
        (l += '</div>'),
        (l += '</div>'),
        (l += '<div class="art-Card_Content">'),
        (l += '<h3 class="art-Card_Title fz-2432">' + e.contentTitle),
        (l += '</h3>'),
        (l += '<div class="art-Card_Text fz-1323">' + e.contentDescription + '</div>'),
        (l += '</div>'),
        (l += '</a>'),
        (l += '</li>')
      )
    },
    displayNoResultData: function (e) {
      e.msgToShow || (e = klevu_commons.getNoResultsData(klevu_uiLabels.noRecords, e))
      var t,
        l = '',
        n = e.products || [],
        r = klevu_userOptions.noResultsOptions,
        a = !1,
        i = document.createElement('div')
      if (
        ((l += '<div class="klevuSearchNoResults-Inner">'),
        (l +=
          '<div class="klevuNoResults-message" aria-live="assertive" role="status" tabindex="0">' +
          e.msgToShow +
          '</div>'),
        n && n.length > 0)
      ) {
        var s = 'undefined' != typeof klevu_lang && '' !== klevu_lang ? klevu_lang : 'en'
        ;(l += '<div class="klevuSearchNoResultsBlock">'),
          (l += '<div class="klevuSearchNoResults-l2">'),
          (l +=
            '<div class="klevuSearchNoResultsHeading">' +
            ku_translations[s].youMayAlsoLike +
            '</div>'),
          (l += '<ul>')
        for (var o = 0; o < n.length; o++) l += '<li>'
        l += '<div class="prd-Card util-FauxLink">'
        l += `<a class="prd-Card_FauxLink util-FauxLink_Link" href="${
          n[o].url
        }" target="_blank"></a>`
        l += `<div class="prd-Card_ImageContainer">`
        const productImage =
          n[o].imageUrl.indexOf('_400x800.jpg') >= 0
            ? n[o].imageUrl.replace('_400x800.jpg', '_900x.jpg')
            : n[o].imageUrl
        l += `<div class="prd-Card_Image"><img src="${productImage}" class="prd-Card_KlevuImage" onerror="this.onerror=null;this.src='${
          klevu_userOptions.noImageUrl
        }';" alt="${n[o].name}"/></div>`
        l += '</div>'
        l += '<div class="prd-Card_Content">'
        l += `<h3 class="prd-Card_Title fz-1525">${n[o].name
          .split('|')[0]
          .replace('·', '<br />')}</h3>`
        l += '<div class="prd-Card_Price fz-1525">'
        if (klevu_showPrices) {
          l += klevu_landingProductElements.showPrices(n[o], 'prd-Product_Price').replace('.00', '')
        }
        l += '</div>'
        l += '</div>'
        l += '</div>'
        l += '</li>'
        ;(l += '</ul>'), (l += '</div>'), (l += '</div>')
      }
      if (
        (e.banner &&
          e.banner.showOnQuickSearch &&
          ((trackingParams =
            "{id: '" +
            e.banner.bannerRef +
            "',name: '" +
            e.banner.bannerName +
            "',image: '" +
            escape(e.banner.bannerImageUrl) +
            "',redirectUrl: '" +
            e.banner.redirectUrl +
            "'}"),
          klevu_commons.isMobileDevice()
            ? (trackingEvent = ' onclick=')
            : (trackingEvent =
                ' onclick="klevu_analytics.stopClickDefault( event );"  onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
                trackingParams +
                ', klevu_analytics.trackClickedBannerAds);"  onmousedown='),
          (trackingEvent +=
            '"return klevu_analytics.trackClickedBannerAds(event, ' +
            trackingParams +
            ');" target="_blank">'),
          (l +=
            '<div class="kuNoResults-banner"><a href="' +
            e.banner.redirectUrl +
            '" ' +
            trackingEvent +
            '<img src="' +
            e.banner.bannerImageUrl +
            '" alt="' +
            e.banner.bannerName +
            '"/></a></div>')),
        ((r && r.showPopularKeywords) || klevu_userOptions.showPopularKeywordsForNoResult) &&
          (a = !0),
        'undefined' != typeof klevu_webstorePopularTerms && klevu_webstorePopularTerms && a)
      ) {
        var u = klevu_webstorePopularTerms,
          c = 1
        if (
          ((l += '<div class="klevuNoResults-pSearch">'),
          (l +=
            '<strong class="klevuNoResults-pSearchTitle">' +
            klevu_uiLabels.popularSearches +
            ' </strong>'),
          u && u.length > 0)
        )
          for (o = 0; o < u.length; o++) {
            0 !== o && (l += ', ')
            try {
              l +=
                '<a href="' +
                e.landingPageUrl +
                encodeURIComponent(decodeURIComponent(u[o])) +
                '" target="_self">' +
                decodeURIComponent(u[o]) +
                '</a>'
            } catch (e) {
              continue
            }
            if (5 == c) break
            c++
          }
        l += '</div>\x3c!-- ends klevuNoResults-popularSearch--\x3e'
      }
      return (l += '</div>\x3c!-- ends klevuNoResults-Inner--\x3e')
    },
    loadLayout: function () {
      'undefined' != typeof klevuLayoutVersion
        ? ((klevu_userOptions.autoComplete = !0),
          'undefined' != typeof klevu_categorySearchEnabled &&
            klevu_categorySearchEnabled &&
            (klevu_userOptions.autoCompleteFilters = 'category'),
          ('undefined' != typeof klevu_cms_module_enabled &&
            klevu_cms_module_enabled &&
            klevu_cmsSearchEnabled) ||
          ('undefined' != typeof klevu_shopifyStore &&
            klevu_shopifyStore &&
            'undefined' != typeof klevu_cmsEnabled &&
            klevu_cmsEnabled) ||
          ('undefined' != typeof klevu_bigCommerceStore &&
            klevu_bigCommerceStore &&
            'undefined' != typeof klevu_cmsEnabled &&
            klevu_cmsEnabled)
            ? ((klevu_userOptions.cmsEnabled = !0),
              (klevu_cmsApiKey = klevu_apiKey),
              klevu_userOptions.autoCompleteFilters.trim().length > 0
                ? (klevu_userOptions.autoCompleteFilters += ':cms')
                : (klevu_userOptions.autoCompleteFilters = 'category:cms'))
            : (klevu_userOptions.cmsEnabled = !1),
          (klevu_userOptions.layoutVersion = '2.0'),
          (klevu_userOptions.recordsPerPage = 3),
          'undefined' != typeof klevu_productsToShowInSlimLayout &&
            (klevu_userOptions.recordsPerPage = klevu_productsToShowInSlimLayout),
          (klevu_userOptions.fetchFilters = !1),
          (klevu_userOptions.rsPsClickBehaviour = 'redirect'),
          'undefined' != typeof klevu_rsPsClickBehaviour &&
            (klevu_userOptions.rsPsClickBehaviour = klevu_rsPsClickBehaviour || 'redirect'),
          void 0 !== klevu_uc &&
            void 0 !== klevu_uc.showResultsData &&
            (klevu_layout.renderResults = klevu_uc.showResultsData),
          void 0 !== klevu_uc &&
            void 0 !== klevu_uc.addAutocompleteLayoutToPage &&
            (klevu_layoutSetup.addLayoutToPage = klevu_uc.addAutocompleteLayoutToPage),
          void 0 !== klevu_uc &&
            void 0 !== klevu_uc.showAutocompleteProducts &&
            (klevu_layout.displayProductdata = klevu_uc.showAutocompleteProducts),
          void 0 !== klevu_uc &&
            void 0 !== klevu_uc.displayNoResultData &&
            (klevu_layout.displayNoResultData = klevu_uc.displayNoResultData),
          klevu_layoutSetup.addLayoutToPage(document.getElementsByTagName('body')[0]),
          uc_helperFunctions.focusThirdPartyInput())
        : setTimeout(klevu_loadLayout, 200)
    }
  }
function klevu_afterLandingResultsLoaded (e) {
  uc_helperFunctions.goToCMS(),
    uc_helperFunctions.addBodyClass(),
    screenWidthCheck() ||
      (uc_helperFunctions.moveFilters(), uc_helperFunctions.onlyOneFacetOpened()),
    uc_helperFunctions.moveSelectedFilters(),
    uc_helperFunctions.customSelect(),
    uc_helperFunctions.closeFacets(),
    screenWidthCheck() &&
      (uc_helperFunctions.addFilterOpener(),
      uc_helperFunctions.mobFilterContainer(),
      uc_helperFunctions.applyButtonFunctionality(),
      uc_helperFunctions.closeOnApplyClick()),
    uc_helperFunctions.addFilterTopClass(),
    uc_helperFunctions.renameProductTab(),
    uc_helperFunctions.renameCMSTab(),
    uc_helperFunctions.priceRangeRename(),
    uc_helperFunctions.removeFilterClass(),
    uc_helperFunctions.clearFacetFunctionality()
}
function klevu_afterLandingCmsResultsLoaded (e) {
  uc_helperFunctions.renameCMSTab()
}
var uc_helperFunctions = {
  addBodyClass: function () {
    document.getElementsByTagName('body')[0].classList.add('klevu_page')
  },
  addFilterOpener: function () {
    var e = 'undefined' != typeof klevu_lang && '' !== klevu_lang ? klevu_lang : 'en',
      t =
        '<div class="ku-filterOpener" onclick="uc_helperFunctions.openCloseFilter()">' +
        ku_translations[e].filterBy +
        '</div>'
    !document.querySelector('.ku-filterOpener') &&
      document.querySelector('.kuSortHeader') &&
      document.querySelector('.kuSortHeader').insertAdjacentHTML('beforeend', t)
  },
  openCloseFilter: function () {
    document.getElementsByTagName('body')[0].classList.toggle('kuFilters_opened')
  },
  mobFilterContainer: function () {
    var e = 'undefined' != typeof klevu_lang && '' !== klevu_lang ? klevu_lang : 'en',
      t = '\n    <div class="ku-mobFilterContainer">\n    <div class="ku-closeMobFilter" onclick="uc_helperFunctions.openCloseFilter()" >'
        .concat(
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M15.314 4l.565.566-5.374 5.373 5.374 5.375-.565.565-5.375-5.374-5.373 5.374L4 15.314l5.374-5.375L4 4.566 4.566 4l5.373 5.374L15.314 4z"/></svg>',
          '</div>\n      <div class="ku-mobFilterContainer-header">\n        \n        <div>'
        )
        .concat(
          ku_translations[e].filterBy,
          '</div>\n      </div>\n      <div class="ku-mobFilterContainer-footer">\n        <button id="applyFilter">'
        )
        .concat(ku_translations[e].apply, '</button>\n      </div>\n    </div>')
    document.querySelector('.ku-mobFilterContainer') ||
      document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', t),
      document.getElementById('kuFilters') &&
        document.querySelector('.ku-mobFilterContainer') &&
        ((document.getElementById('kuFilters').style.display = 'block'),
        setTimeout(function () {
          document
            .querySelector('.ku-mobFilterContainer')
            .insertAdjacentElement('afterbegin', document.getElementById('kuFilters'))
        }, 0))
  },
  applyButtonFunctionality: function () {
    var e = ''
    document.querySelectorAll('.kuFilterNames ul li a').forEach(function (t) {
      t.onclick = function (l) {
        l.preventDefault()
        var n = l.target.closest('li'),
          r = document.getElementById('applyFilter').getAttribute('onclick'),
          a = t.getAttribute('onclick')
        n.classList.toggle('kuSelected'),
          null !== r && -1 !== r.indexOf(a)
            ? ((e = e.replace(a, '')),
              document.getElementById('applyFilter').setAttribute('onclick', e))
            : ((e += a), document.getElementById('applyFilter').setAttribute('onclick', e))
      }
    })
  },
  customSelect: function () {
    var e, t, l, n, r, a, i
    0 === document.querySelectorAll('.select-selected').length &&
      (function () {
        var s = function (e) {
          var t,
            l,
            n,
            r = []
          for (
            t = document.getElementsByClassName('select-items'),
              l = document.getElementsByClassName('select-selected'),
              n = 0;
            n < l.length;
            n++
          )
            e == l[n] ? r.push(n) : l[n].classList.remove('select-arrow-active')
          for (n = 0; n < t.length; n++) r.indexOf(n) && t[n].classList.add('select-hide')
        }
        for (e = document.getElementsByClassName('kuSortby'), t = 0; t < e.length; t++) {
          for (
            n = e[t].getElementsByTagName('select')[0],
              (r = document.createElement('DIV')).setAttribute('class', 'select-selected'),
              r.innerHTML = n.options[n.selectedIndex].innerHTML,
              e[t].appendChild(r),
              (a = document.createElement('DIV')).setAttribute('class', 'select-items select-hide'),
              l = 0;
            l < n.length;
            l++
          )
            ((i = document.createElement('DIV')).innerHTML = n.options[l].innerHTML),
              i.setAttribute('data-value', n.options[l].value),
              i.addEventListener('click', function (e) {
                var t, l, n, r, a
                for (
                  r = this.parentNode.parentNode.getElementsByTagName('select')[0],
                    a = this.parentNode.previousSibling,
                    klevu_changeSortingOptionsForLandigPage(this.getAttribute('data-value')),
                    l = 0;
                  l < r.length;
                  l++
                )
                  if (r.options[l].innerHTML == this.innerHTML) {
                    for (
                      r.selectedIndex = l,
                        a.innerHTML = this.innerHTML,
                        t = this.parentNode.getElementsByClassName('same-as-selected'),
                        n = 0;
                      n < t.length;
                      n++
                    )
                      t[n].removeAttribute('class')
                    this.setAttribute('class', 'same-as-selected')
                    break
                  }
                a.click()
              }),
              a.appendChild(i)
          e[t].appendChild(a),
            r.addEventListener('click', function (e) {
              document.querySelectorAll('.select-items > .same-as-selected').length <= 0 &&
                document
                  .querySelectorAll('.select-items > div')[0]
                  .classList.add('same-as-selected'),
                e.stopPropagation(),
                s(this),
                this.nextSibling.classList.toggle('select-hide'),
                this.classList.toggle('select-arrow-active')
            })
        }
        document.addEventListener('click', s)
      })()
  },
  moveFilters: function () {
    document.getElementById('kuFilters') &&
      document.querySelector('.kuSortHeader') &&
      !document.querySelector('.kuSortHeader #kuFilters') &&
      document
        .querySelector('.kuSortHeader')
        .insertAdjacentElement('afterbegin', document.getElementById('kuFilters'))
  },
  moveSelectedFilters: function () {
    document.getElementById('ku-search-filter-tags') &&
      document.querySelector('.kuSortHeader') &&
      !document.querySelector('#kuProductContent #ku-search-filter-tags') &&
      document
        .querySelector('.kuSortHeader')
        .insertAdjacentElement('afterend', document.getElementById('ku-search-filter-tags'))
  },
  closeFacets: function () {
    Array.prototype.slice
      .call(document.querySelectorAll('#kuFilters .kuFilterHead'))
      .forEach(function (e) {
        ;(e.parentElement.style.height = '50px'),
          e.classList.remove('kuCollapse'),
          e.classList.add('kuExpand'),
          (e.nextElementSibling.style.cssText = 'display: none;')
      })
  },
  closeOnApplyClick: function () {
    document.getElementById('applyFilter') &&
      document.getElementById('applyFilter').addEventListener('click', function () {
        document.getElementsByTagName('body')[0].classList.remove('kuFilters_opened')
      })
  },
  goToCMS: function () {
    var e = new URL(window.location.href)
    if ('true' === e.searchParams.get('goToCMS')) {
      e.searchParams.delete('goToCMS')
      var t = e.toString()
      window.history.replaceState(null, null, t), klevu_changeKuTab('other')
    }
  },
  ifNoResults: function (e, t) {
    0 === e
      ? document.getElementById('klevuSearchingArea').classList.add(t)
      : document.getElementById('klevuSearchingArea').classList.remove(t)
  },
  addFilterTopClass: function () {
    document.getElementById('kuMainContainer') &&
      (document.getElementById('kuMainContainer').classList.remove('kuFiltersLeft'),
      document.getElementById('kuMainContainer').classList.add('kuFiltersTop'))
  },
  changeImageSize: function (e, t, l) {
    try {
      e.image && (e.image = -1 !== e.image.indexOf(l) ? e.image.replace(l, t) : e.image),
        e.imageUrl &&
          (e.imageUrl = -1 !== e.imageUrl.indexOf(l) ? e.imageUrl.replace(l, t) : e.imageUrl),
        e.imageHover &&
          (e.imageHover =
            -1 !== e.imageHover.indexOf(l) ? e.imageHover.replace(l, t) : e.imageHover),
        (e.productImage = e.image)
    } catch (e) {
      console.log(e)
    }
  },
  renameProductTab: function () {
    if (document.getElementById('kuProductTab')) {
      var e = 'undefined' != typeof klevu_lang && '' !== klevu_lang ? klevu_lang : 'en'
      document.getElementById('kuProductTab').innerHTML =
        ku_translations[e].products + ' (' + klevu_pagination.totalLandingResultsFound + ')'
    }
  },
  renameCMSTab: function () {
    if (document.getElementById('kuOtherTab')) {
      var e = 'undefined' != typeof klevu_lang && '' !== klevu_lang ? klevu_lang : 'en'
      klevu_pagination.totalLandingCmsResultsFound > 0
        ? (document.getElementById('kuOtherTab').innerHTML =
            ku_translations[e].blog + ' (' + klevu_pagination.totalLandingCmsResultsFound + ')')
        : (document.getElementById('kuOtherTab').innerHTML = ku_translations[e].blog)
    }
  },
  priceRangeRename: function () {
    document.getElementById('kuFilterHead-Price_Range') &&
      (document.getElementById('kuFilterHead-Price_Range').innerText = 'Price Range')
  },
  closeQuickSearch: function () {
    document.getElementById('klevuSearchingArea') &&
      (document.getElementById('klevuSearchingArea').style.display = 'none')
  },
  removeFilterClass: function () {
    document.getElementById('kuMainContainer') &&
      (document.getElementById('kuMainContainer').classList.remove('kuFiltersTop'),
      document.getElementById('kuMainContainer').classList.add('kuFiltersLeft'))
  },
  clearFacetFunctionality: function () {
    document.querySelectorAll('.kuSelected').length > 0 &&
      Array.prototype.slice.call(document.querySelectorAll('.kuFilterBox')).forEach(function (e) {
        var t = ''
        e.querySelectorAll('.kuSelected').length > 0 && e.classList.add('ku-contain-selected'),
          Array.prototype.slice.call(e.querySelectorAll('.kuSelected')).forEach(function (l) {
            ;(t += l.firstElementChild.getAttribute('onclick')),
              e.querySelector('.ku-clear-facet').setAttribute('onclick', t)
          })
      })
  },
  scrollToProduct: function () {
    var e = new URL(window.location.href),
      t = e.searchParams
    if (null !== e.searchParams.get('scrollTo')) {
      var l = t.get('scrollTo')
      window.scrollTo(0, l)
    }
    if (null !== e.searchParams.get('scrollTo')) {
      t.delete('scrollTo')
      var n = e.toString()
      history.pushState(-1, 'title', n)
    }
  },
  addScrollToParameterToURL: function () {
    if (window.history && history.pushState && document.getElementById('kuLandingProductsListUl')) {
      document.getElementById('kuLandingProductsListUl').removeEventListener('click', e)
      var e = function (e) {
        try {
          if ('kuLandingProductsListUl' !== e.target.id) {
            var t = (function e (t) {
              return 'LI' === t.tagName ? t : t.parentNode && e(t.parentNode)
            })(e.target)
            if ('LI' === t.tagName) {
              var l = new URL(window.location.href),
                n = l.searchParams,
                r = Math.round(window.pageYOffset + t.getBoundingClientRect().y)
              if (null === l.searchParams.get('scrollTo')) {
                n.append('scrollTo', r)
                var a = l.toString()
                history.pushState(-1, 'title', a)
              } else {
                n.set('scrollTo', r)
                var i = l.toString()
                history.pushState(-1, 'title', i)
              }
            }
          }
        } catch (e) {
          console.log(e)
        }
      }
      document.getElementById('kuLandingProductsListUl').addEventListener('click', e)
    }
  },
  focusThirdPartyInput: function () {
    try {
      var e = document.getElementById('klevu-pt-rs-hover'),
        t = document.getElementById('klevuSearchingArea'),
        l = document.getElementById('ku-search-field'),
        n = document.getElementsByTagName('body')[0]
      null !== l &&
        l.addEventListener('click', function () {
          n.classList.add('klevu-upon-third-party-input')
        })
      var r = new MutationObserver(function (e, t) {
        var r = !0,
          a = !1,
          i = void 0
        try {
          for (var s, o = e[Symbol.iterator](); !(r = (s = o.next()).done); r = !0) {
            var u = s.value
            u.attributeName && 'none' !== u.target.style.display
              ? (n.classList.add('klevu-quick-autocomplete'),
                null !== l &&
                  l === document.activeElement &&
                  n.classList.add('klevu-upon-third-party-input'))
              : 'block' !== u.target.style.display &&
                (n.classList.remove('klevu-quick-autocomplete'),
                n.classList.remove('klevu-upon-third-party-input'))
          }
        } catch (e) {
          ;(a = !0), (i = e)
        } finally {
          try {
            r || null == o.return || o.return()
          } finally {
            if (a) throw i
          }
        }
      })
      r.observe(e, { attributes: !0 }), r.observe(t, { attributes: !0 })
    } catch (e) {
      console.log('KLEVU Mutation observer error', e)
    }
  },
  onlyOneFacetOpened: function () {
    function e (e) {
      e.target.classList.contains('kuCollapse') &&
        (uc_helperFunctions.closeFacets(),
        (e.target.parentElement.style.height = 'auto'),
        e.target.classList.add('kuCollapse'),
        e.target.classList.remove('kuExpand'),
        (e.target.nextElementSibling.style.cssText = 'display: block;'))
    }
    document.getElementById('kuFilters').removeEventListener('click', e),
      document.getElementById('kuFilters').addEventListener('click', e)
  },
  fetchProductCard: function (e) {
    if (!e || !e.productCode) return

    fetch(`${e.productUrl}/?section_id=klevu-product-card`)
      .then(res => res.text())
      .then(html => {
        uc_helperFunctions.addProductCard(html, e)
      })
  },
  addProductCard: function (html, e) {
    // Replace the full product card so we have control over which variant is shown.
    // For example, we don't want to use Memo Order / Reserve / Wholesale variants.
    const { productCode } = e

    // Don't run if quick search is open.
    const isQuickSearchOpen = uc_helperFunctions.isQuickSearchOpen()
    if (isQuickSearchOpen) return

    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    const productCard = doc.querySelector('[data-product-card]')
    if (!productCard) return

    productCard.setAttribute('data-product-card-loaded', '')
    productCard.setAttribute('data-product-id', productCode)

    const targetProductCard = document.querySelector(`[data-product-id="${productCode}"]`)
    if (!targetProductCard) return

    const parentEl = targetProductCard.closest('li')
    if (!parentEl) return

    parentEl.innerHTML = ''
    parentEl.append(productCard)
  },
  isQuickSearchOpen: function () {
    return (
      document.getElementById('klevuSearchingArea') &&
      document.getElementById('klevuSearchingArea').style.display === 'block'
    )
  }
}
function klevu_uc_productCustomizations (e) {
  // uc_helperFunctions.fetchSampleButton(e)
  uc_helperFunctions.fetchProductCard(e)

  return uc_helperFunctions.changeImageSize(e, '_400x800', '_medium'), e
}
function screenWidthCheck (e) {
  return (
    e || (e = 767),
    (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) <= e
  )
}
